import { inject, Injectable } from '@angular/core';
import { PermissionService } from '@rms/user';
import { map, Observable } from 'rxjs';

import { NavigationItem } from './navigation-item.interface';

@Injectable({
  providedIn: 'root',
})
export class NavigationLoaderService {
  public readonly items$: Observable<NavigationItem[]> = inject(PermissionService).isSupervisor$.pipe(
    map((isSupervisor) => this.buildNavigation(isSupervisor))
  );

  private buildNavigation(isSupervisor: boolean): NavigationItem[] {
    return [
      {
        type: 'link',
        label: 'layout.menu.showcase',
        route: '/showcase',
        icon: 'remix:Design/palette-line',
        hoverIcon: 'remix:Design/palette-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'layout.menu.home',
        route: '/home',
        icon: 'remix:Buildings/home-smile-2-line',
        hoverIcon: 'remix:Buildings/home-smile-2-fill',
        routerLinkActiveOptions: { exact: true },
      },
      ...(isSupervisor
        ? [
            {
              type: 'link' as const,
              label: 'layout.menu.partners',
              route: '/partners',
              icon: 'remix:Business/briefcase-line',
              hoverIcon: 'remix:Business/briefcase-fill',
              routerLinkActiveOptions: { exact: false },
            },
          ]
        : []),
      {
        type: 'link',
        label: 'layout.menu.customers',
        route: '/customers',
        icon: 'remix:User & Faces/user-heart-line',
        hoverIcon: 'remix:User & Faces/user-heart-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'layout.menu.team',
        route: '/team',
        icon: 'remix:User & Faces/team-line',
        hoverIcon: 'remix:User & Faces/team-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'external-link',
        label: 'layout.menu.tolt',
        url: 'https://app.tolt.com',
        icon: 'logo:tolt',
      },
    ];
  }
}
